<template>
  <v-app class="wrapper" id="card-wrapper">
    <v-card class="card-wrapper" flat>
      <v-card-title
        v-if="title"
        :id="titleId"
        class="pt-3 pb-0 d-flex"
        :class="{
          'justify-space-between': actionButtonData,
          'justify-center': !actionButtonData,
        }">
        <toolbar-card
          :title="title"
          :hideCloseBtn="hideCloseBtn"
          :titleStyles="actionButtonData && hideCloseBtn ? {position: 'absolute'} : {}"
          @openCloseCancelDialog="$emit('openCloseCancelDialog')" />
        <m-btn
          v-if="actionButtonData"
          variant="outlined"
          class="btn-secondary"
          style="position: absolute; right: 24px; padding: 0 12px !important; border-radius: 8px !important"
          @click="handleClick()">
          <v-icon dense class="mr-2">{{ actionButtonData.icon }}</v-icon>
          {{ actionButtonData.title }}
        </m-btn>
      </v-card-title>
      <v-divider v-if="showDivider" class="custom-separator mx-6" />

      <v-card-text :class="paddingText">
        <slot />
      </v-card-text>
    </v-card>
  </v-app>
</template>

<script lang="ts">
import {defineComponent, PropType} from '@vue/composition-api'
import VueI18n from 'vue-i18n'

import ToolbarCard from '@/components/registrations/HondaRegistration/ToolbarCard.vue'

export default defineComponent({
  name: 'CardWrapper',
  components: {ToolbarCard},
  props: {
    title: {
      type: String as PropType<string | VueI18n.TranslateResult>,
      required: true,
    },
    titleId: {
      type: String,
      default: '',
    },
    hideCloseBtn: {
      type: Boolean,
      default: true,
    },
    showDivider: {
      type: Boolean,
      default: true,
    },
    actionButtonData: {
      type: Object,
      default: null,
    },
    paddingText: {
      type: String,
      default: 'pa-8',
    },
  },
  setup(props, {root, emit}) {
    function handleClick() {
      emit('on-open-action-button-dialog')
    }

    return {
      handleClick,
    }
  },
})
</script>

<style lang="scss">
#card-wrapper.wrapper {
  .text-header,
  .text-center,
  .text-left {
    &.sortable.no-padding-left,
    &.no-padding-left {
      padding-left: 0 !important;
    }

    &:has(.no-padding-left) {
      padding-left: 0 !important;
    }

    &.sortable.no-padding-right,
    &.no-padding-right {
      padding-right: 0 !important;
    }

    &:has(.no-padding-right) {
      padding-right: 0 !important;
    }
  }

  .v-data-table-header {
    .v-data-table-header__icon:before {
      position: absolute !important;
    }

    tr {
      padding-top: 8px;

      th {
        height: 34px !important;
      }
    }
  }

  .v-data-footer {
    padding-top: 16px;

    .v-data-footer__icons-before,
    .v-data-footer__icons-after {
      .v-btn > .v-btn__content .v-icon {
        font-size: 18px !important;
        height: 18px !important;
        width: 18px !important;
      }
    }
  }
}
</style>

<style scoped>
.wrapper {
  background: transparent !important;
  padding: 40px;
}

.wrapper .card-wrapper {
  border-radius: 9px;
  box-shadow: 0 0 18px rgb(0 0 0 / 10%) !important;
}
</style>
